import Cookies from "js-cookie";

export const setCookie = (
  name: string,
  value: string,
  expires: number,
  path = "/",
): void => {
  Cookies.set(name, value, { expires, path });
};

export const getCookie = (cookieName: string): string | undefined =>
  Cookies.get(cookieName);

export const deleteCookie = (cookieName: string) => Cookies.remove(cookieName);
